import React from 'react';
import '@digdir/designsystemet-css';
import '@brreg/designsystemet-theme/css/brreg.css';
import './footer.css';
import { Link } from '@digdir/designsystemet-react';

export const Footer = ({ logoImageSvgData }: { logoImageSvgData: string }) => {
	return (
		<footer>
			<section>
				<div>
					<div
						className="logo"
						dangerouslySetInnerHTML={{ __html: logoImageSvgData }}
					></div>
				</div>
				<div>
					<Link href="https://www.brreg.no/">
						Organisasjonsnummer 974 760 673
					</Link>
				</div>
			</section>

			<section>
				<div>
					<Link href="https://www.brreg.no/personvernerklaering/">
						Personvernerklæring
					</Link>
				</div>
				<div>
					<Link href="https://www.brreg.no/tilgjengelighetserklaeringer/">
						Tilgjengelighetserklæring
					</Link>
				</div>
			</section>

			<section>
				<div>
					<Link href="https://www.linkedin.com/company/bronnoysundregistrene/">
						Finn oss på LinkedIn
					</Link>
				</div>
				<div>
					<Link href="https://www.instagram.com/bronnoysundregistrene/">
						Finn oss på Instagram
					</Link>
				</div>
				<div>
					<Link href="https://forenkling.brreg.no/">
						Forenklingsbloggen
					</Link>
				</div>
			</section>
		</footer>
	);
};
